export default "__VITE_ASSET__cab97c07__"